import { DocumentIcon } from "@heroicons/react/24/outline";
import { FC } from "react";
import ProductDetailHeader from "./ProjectDetailHeader";
import { useProjectStore } from "@/stores/projectStore";

const DocumentList: FC = () => {
  const { selectedProjectDocuments } = useProjectStore();

  return (
    <div className="grid gap-2">
      <ProductDetailHeader
        icon={<DocumentIcon className={`w-5 h-5 mr-2 text-black`} />}
        label="Documents"
      />
      <div className="flex flex-wrap gap-2">
        {selectedProjectDocuments?.map((doc, index) => (
          <div
            key={index}
            className="flex flex-col p-4 bg-slate-100	 rounded-lg text-center hover:shadow-lg transition items-center w-44 h-40  "
          >
            <img
              src="/images/documentImage.png"
              alt="project logo"
              className="w-16 h-16"
            />
            <h4 className="text-cyan-800 font-medium text-sm truncate w-full">
              {doc.title}
            </h4>
            <p className="text-cyan-800 text-xs text-center w-full">
              {doc.subTitle}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DocumentList;
